import request from '@/util/request'


export const trainGerenalList = (data) => request.post('/api/trainGerenalList', data);  //通用培训项目列表

export const trainGerenalAdd = (data) => request.post('/api/trainGerenalAdd', data);  //通用培训项目添加

export const trainGerenalEdit = (data) => request.post('/api/trainGerenalEdit', data);  //通用培训项目编辑

export const trainGerenalStatus = (data) => request.post('/api/trainGerenalStatus', data);  //通用培训项目更改状态

export const trainGerenalDel = (data) => request.post('/api/trainGerenalDel', data);  //通用培训项目删除

export const trainGerenalDetail = (data) => request.post('/api/trainGerenalDetail', data);  //通用培训项目详情

export const trainGerenalAddUser = (data) => request.post('/api/trainGerenalAddUser', data);  //通用培训项目分配用户

export const trainGerenaldelUser = (data) => request.post('/api/trainGerenaldelUser', data);  //通用培训项目删除用户

export const trainGerenaleditUser = (data) => request.post('/api/trainGerenaleditUser', data);  //通用培训项目编辑用户